'use strict';

const cssClass = 'is-loading';
const defaultLoaderClass = 'Loader--white';
const template = '<div class="Button-loader"><div class="Loader Loader--small"></div></div>';
const saButtonLoader = function () {
  return {
    restrict: 'A',
    scope: {
      'saButtonLoader': '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [
      '$scope',
      '$element',
      '$attrs',

      function ($scope, $element, $attrs) {
        var loaderClass = $attrs.hasOwnProperty('loaderClass') && ($attrs.loaderClass || '') || defaultLoaderClass;
        var loader;

        function showLoader() {
          $element.addClass(cssClass);

          if (!loader) {
            loader = angular.element(template);
            loader.children().addClass(loaderClass);
            $element.append(loader);
          }
        }

        function hideLoader() {
          if (loader) {
            loader.remove();
            loader = null;
          }
          $element.removeClass(cssClass);
        }

        $scope.$watch('ctrl.saButtonLoader', function (isLoading) {
          if (isLoading) {
            showLoader();
          } else {
            hideLoader();
          }
        });
      }
    ]
  };
};

export default saButtonLoader;



// WEBPACK FOOTER //
// ./app/src/directives/button_loader.js